<template>
  <div>
    <div class="button bg-gold hover:bg-gold-dark text-cream mx-auto cusor-pointer relative" v-if="!filename">
      <input class="opacity-0 absolute pin-x pin-y" type="file" name="cover_image" v-on:change="updateFile">
      Add Cover Image
    </div>
    <a class="no-underline text-grey" href="#" v-else>
        <span class="text-xs bg-white py-4 px-2">{{ filename }}</span><span class="border border-red p-2 text-cream bg-red hover:bg-red-dark hover:text-white text-xs" v-on:click="changeFile">Change File</span>
    </a>
  </div>
</template>

<script>
  export default {
    props: ['type'],
    data() {
      return {
        filename: ''
      }
    },
    created() {
      console.log(this.type)
    },
    methods: {
      updateFile(e) {
        this.filename = e.target.value.replace("C:\\fakepath\\", "")
        console.log(e.target.value)
        // validate image size & aspect ratio on server?
      },
      changeFile(e) {
        this.filename = ''
      }
    }
  }
</script>
